import React from "react";
import {AddMembershipGroup} from "../../../../UI/MembershipGroup/Add/AddMembershipService";

const AddMembershipGroupPage = () => {
  return (
    <div>
      <AddMembershipGroup />
    </div>
  );
};

export default React.memo(AddMembershipGroupPage);
